"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatReferenceUid = exports.formatFormUid = exports.isReferenceUid = exports.isFormUid = exports.REFERENCE_UID_PREFIX = exports.FORM_UID_PREFIX = exports.PortalContext = exports.ALL_SPECIALTIES = exports.LEGACY_SPECIALTIES = exports.ACTIVE_SPECIALTIES = exports.Specialty = void 0;
var Specialty;
(function (Specialty) {
    Specialty["Vascular"] = "vascular";
    Specialty["Fertility"] = "fertility";
    Specialty["HairTransplant"] = "hair_transplant";
    Specialty["PlasticSurgery"] = "plastic_surgery";
    Specialty["DiagnosticsImaging"] = "diagnostics_imaging";
    Specialty["Dentistry"] = "dentistry";
    Specialty["Optical"] = "optical";
    Specialty["StemCells"] = "stem_cells";
    Specialty["Cosmetic"] = "cosmetic";
    Specialty["Optics"] = "optics";
    Specialty["DiagnosisTesting"] = "diagnosis_testing";
    Specialty["Orthopedic"] = "orthopedic";
    Specialty["Cardiology"] = "cardiology";
    Specialty["Dermatology"] = "dermatology";
    Specialty["General"] = "general";
})(Specialty || (exports.Specialty = Specialty = {}));
exports.ACTIVE_SPECIALTIES = [
    Specialty.Vascular,
    Specialty.Fertility,
    Specialty.HairTransplant,
    Specialty.PlasticSurgery,
    Specialty.DiagnosticsImaging,
    Specialty.Dentistry,
    Specialty.Optical,
    Specialty.StemCells,
];
exports.LEGACY_SPECIALTIES = [
    Specialty.Cosmetic,
    Specialty.Optics,
    Specialty.DiagnosisTesting,
    Specialty.Orthopedic,
    Specialty.Cardiology,
    Specialty.Dermatology,
    Specialty.General,
];
exports.ALL_SPECIALTIES = [...exports.ACTIVE_SPECIALTIES, ...exports.LEGACY_SPECIALTIES];
var PortalContext;
(function (PortalContext) {
    PortalContext["Patient"] = "patient";
    PortalContext["Doctor"] = "doctor";
    PortalContext["Admin"] = "admin";
})(PortalContext || (exports.PortalContext = PortalContext = {}));
exports.FORM_UID_PREFIX = "F";
exports.REFERENCE_UID_PREFIX = "R";
const FORM_UID_REGEX = /^F\d{6,}$/;
const REFERENCE_UID_REGEX = /^R\d{6,}$/;
const isFormUid = (value) => FORM_UID_REGEX.test(value);
exports.isFormUid = isFormUid;
const isReferenceUid = (value) => REFERENCE_UID_REGEX.test(value);
exports.isReferenceUid = isReferenceUid;
const formatFormUid = (sequence) => `${exports.FORM_UID_PREFIX}${sequence.toString().padStart(6, "0")}`;
exports.formatFormUid = formatFormUid;
const formatReferenceUid = (sequence) => `${exports.REFERENCE_UID_PREFIX}${sequence.toString().padStart(6, "0")}`;
exports.formatReferenceUid = formatReferenceUid;
//# sourceMappingURL=patient-intake.types.js.map